// extracted by mini-css-extract-plugin
export default {"wrapper":"Blockquote_wrapper__e4dbt","blockquote":"Blockquote_blockquote__nK-lW"};